import React from "react";
import { Box, Paper, Typography } from "@material-ui/core";
import styled from "styled-components/macro";

const Root = styled(Paper)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  padding: 8px 12px 10px;
  max-width: 220px;
`;

// Mirrors the interactive map's legend symbol (12px colored circle) with the
// same 1px black outline the WQ point layer draws around unselected wells.
const Swatch = styled.div`
  background-color: ${({ $color }) => $color};
  border: 1px solid #000;
  border-radius: 50%;
  height: 12px;
  width: 12px;
  min-width: 12px;
`;

// Each row is a real button (keyboard accessible) that toggles its aquifer's
// wells on the map. Toggled-off rows render dimmed.
const Row = styled.button`
  appearance: none;
  border: none;
  background: none;
  font: inherit;
  text-align: left;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: ${({ $off }) => ($off ? 0.35 : 1)};

  &:hover {
    text-decoration: underline;
  }
`;

/**
 * Aquifer-completion legend for the WQ Viewer map. items is
 * [{ label, color }] — already deduped and ordered by the caller. Clicking a
 * row toggles that aquifer's wells on/off (on top of any active parameter
 * filter); disabled holds the toggled-off labels. Renders nothing when
 * items is empty (e.g. summary rows don't carry aquifer fields yet).
 */
const WqMapLegend = ({ items, disabled, onToggle }) => {
  if (!items?.length) return null;
  return (
    <Root elevation={2}>
      <Typography variant="subtitle2">Aquifer Completion</Typography>
      <Typography
        variant="caption"
        color="textSecondary"
        display="block"
        style={{ marginBottom: 6 }}
      >
        Click to show / hide wells
      </Typography>
      <Box display="flex" flexDirection="column" gridRowGap={4}>
        {items.map((item) => {
          const off = disabled?.has(item.label);
          return (
            <Row
              key={item.label}
              type="button"
              $off={off}
              onClick={() => onToggle && onToggle(item.label)}
              title={
                off ? `Show ${item.label} wells` : `Hide ${item.label} wells`
              }
              aria-pressed={!off}
            >
              <Swatch $color={item.color} />
              <Typography color="textSecondary" variant="body2">
                {item.label}
              </Typography>
            </Row>
          );
        })}
      </Box>
    </Root>
  );
};

export default WqMapLegend;
